import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { BackendClient } from './api';

export type AlertColor = 'success' | 'info' | 'warning' | 'error';

export type MenuItemProps = {
  id: number | string;
  title: string;
  seq_id?: number | string;
  children: { id: string | number; title: string; seq_id?: number }[];
};

export type ContentProps = {
  id?: number;
  title: string;
  content: string;
  parent: boolean | number;
  parent_id: string | number;
  seq_id?: string | number | undefined;
  children?: ContentProps[];
};

export type SnackbarStatus = {
  type: AlertColor;
  message: string;
  status: boolean;
  data?: any;
};

export interface DocumentBackendApi {
  saveDocument({
    title,
    content,
    parent,
    parent_id,
  }: ContentProps): Promise<SnackbarStatus>;
  updateDocument({
    id,
    title,
    content,
    parent,
    parent_id,
  }: ContentProps): Promise<SnackbarStatus>;
  getDocuments(menu?: string): Promise<SnackbarStatus>;
  getSingleDocuments(title: string): Promise<SnackbarStatus>;
  deleteDocument(id: number): Promise<SnackbarStatus>;
  getAllParents(): Promise<SnackbarStatus>;
  saveDocumentSequence(item: MenuItemProps[]): Promise<SnackbarStatus>;
  searchDocument(content: string): Promise<SnackbarStatus>;
}

export const documentApiRef = createApiRef<DocumentBackendApi>({
  id: 'plugin.cms.service',
});

export const cmsPlugin = createPlugin({
  id: 'cms',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: documentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
      },
      factory: ({ discoveryApi }) => new BackendClient({ discoveryApi }),
    }),
  ],
});

export const CmsPage = cmsPlugin.provide(
  createRoutableExtension({
    name: 'CmsPage',
    component: () =>
      import('./components/RouteComponent').then(m => m.RouteComponent),
    mountPoint: rootRouteRef,
  }),
);
